import styled from 'styled-components'

import { tooltipStyles } from './styles'

export const AnnotationListPanel = styled.div`
  color: white;
  font-size: 13px;
  display: flex;
  flex-direction: column;
`

export const AnnotationScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-top: 4px;
`

export const AnnotationListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
`

export const AnnotationListTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
`

export const VisibilityToggle = styled.button<{ $visible: boolean }>`
  ${tooltipStyles}
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $visible }) => ($visible ? 'white' : 'rgba(255, 255, 255, 0.4)')};
  transition: color 0.2s;

  &:hover {
    color: ${({ $visible }) =>
      $visible ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.6)'};
  }
`

export const AnnotationListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  &:last-child {
    border-bottom: none;
  }
`

export const AnnotationName = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const FlyToButton = styled.button`
  ${tooltipStyles}
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 4px;
  padding: 6px;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
  }
`

export const ToggleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
`

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
`

export const ToggleLabel = styled.span`
  color: rgba(255, 255, 255, 0.8);
`

export const SmallCheckbox = styled.input`
  cursor: pointer;
  width: 14px;
  height: 14px;
`

export const UnitToggleGroup = styled.div`
  display: flex;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
`

export const UnitToggleButton = styled.button<{ $active: boolean }>`
  background: ${({ $active }) =>
    $active ? 'rgba(255, 255, 255, 0.2)' : 'transparent'};
  border: none;
  color: ${({ $active }) => ($active ? 'white' : 'rgba(255, 255, 255, 0.5)')};
  padding: 2px 8px;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: ${({ $active }) =>
      $active ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.1)'};
  }

  &:not(:last-child) {
    border-right: 1px solid rgba(255, 255, 255, 0.2);
  }
`
